import React, { Component } from 'react'

function ButtonDisabled(props: {onClick:any, name:any, disabled?:any}){
    return(
        <button onClick={props.onClick} className="btn-green btn-disabled" disabled={props.disabled}>{props.name}</button>
    );
}

export default ButtonDisabled;